import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  tool_select_build_and_price: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.BUILD_AND_PRICE
  ),
};

export const TmvMap = {
  ...CommonMap,
  ...map,
};
